import { z } from 'zod'

/**
 * Schema Zod para invitar un usuario (multi-tenant).
 * Migrado desde el schema inline del antiguo UsuarioFormDialog (react-hook-form).
 */
export const invitarUsuarioSchema = z.object({
  email: z.string().min(1, 'El email es requerido').email('Email inválido'),
  nombre: z.string().optional(),
  rol: z.enum(['owner', 'admin', 'profesional', 'asistente', 'solo_lectura']),
  workspaces: z
    .array(z.string())
    .min(1, 'Debe seleccionar al menos un workspace'),
})

export type InvitarUsuarioFormValues = z.infer<typeof invitarUsuarioSchema>

/**
 * Valores por defecto para invitar un usuario nuevo.
 */
export const DEFAULT_USUARIO_VALUES: InvitarUsuarioFormValues = {
  email: '',
  nombre: '',
  rol: 'asistente',
  workspaces: ['contable'],
}
